import type { BusinessServiceRequestWithFirstQueryLoading } from '@ingenico/react-section-utils';
import { useBusinessServiceRequestWithFirstQueryLoading } from '@ingenico/react-section-utils';
import { useCallback } from 'react';
import { DeviceManagementService } from '../domain/business/services/deviceManagement.service';
import type { DeviceInfo } from '../domain/models/deviceInfo.model';

export function useGetDeviceIdV2({
  deviceId,
  shouldFetch = true,
}: {
  readonly deviceId: string;
  readonly shouldFetch?: boolean;
}): BusinessServiceRequestWithFirstQueryLoading<DeviceInfo> {
  return useBusinessServiceRequestWithFirstQueryLoading(
    DeviceManagementService,
    useCallback(
      (deviceManagementService) => {
        return shouldFetch ? deviceManagementService.getDeviceIdV2({ deviceId }) : null;
      },
      [deviceId, shouldFetch],
    ),
  );
}
